import React from 'react'
import Theme12 from './theme12'
const Visa = (props) => {
  const userAgent = typeof navigator === 'undefined' ? '' : navigator.userAgent
  const mobile = Boolean(
    userAgent.match(/Android|BlackBerry|iPhone|iPad|iPod|Opera Mini|IEMobile|WPDesktop/i)
  )
  const theme = props?.pageInfo?.site?.site_theme

  switch (theme) {
    case 'theme12':
      return <Theme12 {...props} />
    default :
      return <Theme12 {...props} />
  }
}

export default Visa
